export const pretifyObject = data => {
    if (!data || typeof data !== 'object') return '';

    const formatValue = (value, indent = 0) => {
        if (value === null) return 'null';
        if (value === undefined) return 'undefined';
        if (Array.isArray(value)) {
            return `[${value.map(v => (typeof v === 'string' ? `${v}` : formatValue(v, indent))).join(', ')}]`;
        }
        if (typeof value === 'object') {
            return formatObjectProps(value, indent + 1);
        }
        if (typeof value === 'string') {
            return value;
        }
        return String(value);
    };

    const formatObjectProps = (obj, indent = 1) => {
        if (!obj || Object.keys(obj).length === 0) return '{}';

        const shift = '    '.repeat(indent);
        const closingBraceShift = '    '.repeat(indent - 1);

        return `{\n${Object.entries(obj)
            .map(([key, val]) => `${shift}${key}: ${formatValue(val, indent)}`)
            .join(',\n')}\n${closingBraceShift}}`;
    };

    return Object.entries(data)
        .map(([key, value]) => `${key}: ${formatValue(value)}`)
        .join(',\n');
};
